<template>
    <div class="w100" ref="main"><!--01033c-->
        <article class="content-bg">
			<div class="content-bg-c">
				
			</div>
			<div style="height: 200px;" v-if="scrollTop >= 960"></div>
			<div class="tab-box" :class="[ scrollTop >= 960 ? 'fixed' : '' ]">
			    <span class="tab-i t1" :class="{'active': talkTab == 0}" @click="talkTab = 0">
					主会场
					<br/>
					<span>
						HONESTY
					</span>
				</span>
			    <span class="tab-i t2" :class="{'active': talkTab == 1}" @click="talkTab = 1">
					同学会分会场
					<br/>
					<span>
						HONESTY
					</span>
				</span>
			    <span class="tab-i t3" :class="{'active': talkTab == 2}" @click="talkTab = 2">
					钢坯分会场
					<br/>
					<span>
						HONESTY
					</span>
				</span>
			    <span class="tab-i t4" :class="{'active': talkTab == 3}" @click="talkTab = 3">
					十佳百强
					<br/>
					<span>
						HONESTY
					</span>
				</span>
			</div>
			<div v-if="talkTab == 0">
				<div class="short-cut">
					<div class="short-cut-bg">
						<div class="s-c-left">
							
						</div>
						<div class="s-c-right">
							<div class="s-c-title">
								驾驭周期：2023年钢铁春季论坛<br/>
								暨2022中国钢铁产业网十佳评选颁奖盛典
							</div>
							<div class="s-c-content">
								&emsp;&emsp;受长周期因素影响，钢铁行业由增量期进入存量期，新周期开启。<br/>
								&emsp;&emsp;已经过去的2022年，是极不平凡的一年，也是钢铁市场跌宕起伏的一年。我们把去年市场定位为行业大逻辑驱动下的复杂态市场：内外部因素发生多点共振，触发出二季度大级别下跌行情；全年的市场虽然V字形收尾，却带有典型的下行周期特点：上涨弱势，下跌猛烈；负反馈主基调，宽震荡为常态。市场复杂程度远超历史各年。2022年市场带给整个行业巨大的冲击，主要表现在:钢企长期处于亏损状态；产业链利润被动挤出；各端企业普遍出现利润压缩、发展受阻、生存艰难等问题。
							</div>
						</div>
					</div>
				</div>
				<div class="zhu-ti" id="zhu-ti">
					<div class="z-t-title"></div>
					<div class="z-t-content">
						<div class="z-t-c-item t1">
							<div class="z-t-c-item-name">
								宋雷
							</div>
							<div class="z-t-c-item-title">
								
							</div>
							<div class="z-t-c-item-post">
								河北唐宋大数据产业股份有限公司董事长
							</div>
						</div>
						<div class="z-t-c-item t2">
							<div class="z-t-c-item-name">
								林采宜
							</div>
							<div class="z-t-c-item-title">
								
							</div>
							<div class="z-t-c-item-post">
								著名经济学家、东亚期货独立董事
							</div>
						</div>
						<div class="z-t-c-item t3">
							<div class="z-t-c-item-name">
								石洪卫
							</div>
							<div class="z-t-c-item-title">
								
							</div>
							<div class="z-t-c-item-post">
								中国钢铁工业协会副秘书长
							</div>
						</div>
						<div class="z-t-c-item t4">
							<div class="z-t-c-item-name">
								李茂津
							</div>
							<div class="z-t-c-item-title">
								
							</div>
							<div class="z-t-c-item-post">
								友发钢管集团董事长 
							</div>
						</div>
						<div class="z-t-c-item t5">
							<div class="z-t-c-item-name">
								钟绍良
							</div>
							<div class="z-t-c-item-title">
								
							</div>
							<div class="z-t-c-item-post">
								世界钢铁协会副总干事、中国区首席 
							</div>
						</div>
						<div class="z-t-c-item t6">
							<div class="z-t-c-item-name">
								张锐
							</div>
							<div class="z-t-c-item-title">
								
							</div>
							<div class="z-t-c-item-post">
								建邦钢铁集团总经理
							</div>
						</div>
						<div class="z-t-c-item t7">
							<div class="z-t-c-item-name">
								王连忠
							</div>
							<div class="z-t-c-item-title">
								
							</div>
							<div class="z-t-c-item-post">
								原国资委司长、熔冶钢铁工业研究院首席专家
							</div>
						</div>
						<div class="z-t-c-item t8">
							<div class="z-t-c-item-name">
								吴昱佳
							</div>
							<div class="z-t-c-item-title">
								
							</div>
							<div class="z-t-c-item-post">
								金仕达产业金融部总监 
							</div>
						</div>
					</div>
				</div>
				<div class="gao-duan" id="gao-duan">
					<div class="g-d-title"></div>
					<div class="g-d-content">
						<div class="g-d-logo"></div>
						<div class="g-d-tstitle">参与访谈嘉宾主题：市场实战型大咖</div>
						<div class="g-d-tscontent">主持人：唐宋大数据副总经理、熔冶研究院院长&emsp;马强</div>
						<div class="g-d-tscontent">河北唐宋大数据产业股份有限公司董事长&emsp;宋雷</div>
						<div class="g-d-tscontent">唐山瑞丰钢铁(集团)有限公司副总经理&emsp;温瑞臣</div>
						<div class="g-d-tscontent">凌源钢铁销售公司总经理&emsp;周国峰</div>
						<div class="g-d-tscontent">旭阳营销有限公司总经理&emsp;陈永会</div>
						<div class="g-d-tscontent">永锋集团供销公司投研总监&emsp;戴召乾</div>
						<div class="g-d-tscontent">北京来巍国际贸易有限公司总经理&emsp;王春艳</div>
						<div class="g-d-picture">
							<el-carousel height="272px" indicator-position="none">
							    <el-carousel-item v-for="i in 8" :key="i">
									<div :class="[ 't' + i ]"></div>
							    </el-carousel-item>
							</el-carousel>
						</div>
					</div>
					<div class="g-d-prople">
						<div class="g-d-p-i" v-for="i in 6">
							
						</div>
					</div>
				</div>
				<div class="zhan-lue" id="zhan-lue">
					<div class="z-l-title"></div>
					<div class="z-l-content">
						<div class="z-l-c-item" v-for="i in 3" :class="[ 't' + i ]">
							
						</div>
					</div>
				</div>
				<div class="chou-jiang" id="chou-jiang">
					<div class="c-j-title"></div>
					<div class="c-j-content">
						<div class="c-j-c-item" v-for="i in 8" :class="[ 't' + i ]">
							
						</div>
					</div>
				</div>
				<div class="wContent center">
				    <!-- 十佳颁奖 -->
				    <div class="meeting-yt">
				        
				    </div>
				
				     <!-- 唐宋学院外聘专家聘任仪式 -->
				    <div class="meeting-yt">
				
				    </div>
				
				    <div class="meeting-yt">
				        <p class="meeting-yt-title center textCenter"><span style="display: inline-block; margin-left: -35px; margin-top: 10px"></span></p>
				
				        <div class="meeting-zanzhu center textCenter">
				            <p class="zanzhu-title mt30">承办单位</p>
				            <el-row :gutter="20">
				                <el-col :span="8" :offset="8">
				                    <div class="zanzhu-center">中国钢铁产业网</div>
				                </el-col>
				            </el-row>
				            <p class="zanzhu-subtitle mt30">联合主办</p>
				            <el-row :gutter="20">
				                <el-col :span="8">
				                    <div class="zanzhu-left">河北唐宋大数据产业股份有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-center">上海东亚期货有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-right">熔冶(北京)钢铁工业研究院</div>
				                </el-col>
				            </el-row>
				
				            <p class="zanzhu-subtitle mt30">支持单位</p>
				            <el-row :gutter="20">
				                <el-col :span="8">
				                    <div class="zanzhu-left">世界钢铁协会</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-center">中国钢铁工业协会</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-right">郑州商品交易所</div>
				                </el-col>
				            </el-row>
							
							<p class="zanzhu-title mt30">钻石赞助</p>
							<el-row :gutter="20">
							    <el-col :span="8" :offset="8">
							        <div class="zanzhu-center">上海金仕达软件科技股份有限公司</div>
							    </el-col>
							</el-row>
							
				            <p class="zanzhu-subtitle mt30">赞助单位</p>
				            <el-row :gutter="20">
				                <el-col :span="8">
				                    <div class="zanzhu-left">天津源泰德润钢铁有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-center">秦皇岛宏兴钢铁有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-right">河北津西钢铁集团股份有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-left">唐山松汀钢铁有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-center">厦门建发金属有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-right">河北安丰钢铁集团有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-left">天津友发钢管集团有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-center">秦皇岛佰工钢铁有限公司</div>
				                </el-col>
				                <el-col :span="8">
				                    <div class="zanzhu-right">天津荣程联合钢铁集团有限公司</div>
				                </el-col>
				            </el-row>
							
							<p class="zanzhu-subtitle mt30">特别鸣谢</p>
							<el-row :gutter="20">
							    <el-col :span="8">
							        <div class="zanzhu-left">陕西钢铁集团有限公司</div>
							    </el-col>
							    <el-col :span="8">
							        <div class="zanzhu-center">山西建邦集团有限公司</div>
							    </el-col>
							    <el-col :span="8">
							        <div class="zanzhu-right">河北鑫达钢铁集团有限公司</div>
							    </el-col>
							    <el-col :span="8">
							        <div class="zanzhu-left">唐山东华钢铁集团有限公司</div>
							    </el-col>
							    <el-col :span="8">
							        <div class="zanzhu-center">唐山首唐宝生功能材料有限公司</div>
							    </el-col>
							    <el-col :span="8">
							        <div class="zanzhu-right">天津市震翔板带加工有限公司</div>
							    </el-col>
							    <el-col :span="8">
							        <div class="zanzhu-left">唐山盛财钢铁有限公司</div>
							    </el-col>
							    <el-col :span="8">
							        <div class="zanzhu-center">唐山市丰润区宝通钢铁有限公司 </div>
							    </el-col>
							    <el-col :span="8">
							        <div class="zanzhu-right">唐山正丰钢铁有限公司</div>
							    </el-col>
								
								<el-col :span="8">
								    <div class="zanzhu-left">浙江盛达铁塔有限公司</div>
								</el-col>
								<el-col :span="8">
								    <div class="zanzhu-center">浙江江丰股份有限公司</div>
								</el-col>
								<el-col :span="8">
								    <div class="zanzhu-right">杭州杭钢对外经济贸易有限公司</div>
								</el-col>
								
								<el-col :span="8">
								    <div class="zanzhu-left">中航国际矿产资源有限公司</div>
								</el-col>
								<el-col :span="8">
								    <div class="zanzhu-center">苏美达国际技术贸易有限公司</div>
								</el-col>
								<el-col :span="8">
								    <div class="zanzhu-right">杭州热联集团股份有限公司</div>
								</el-col>
								
								<el-col :span="8">
								    <div class="zanzhu-left">物产中大金属集团有限公司</div>
								</el-col>
								<el-col :span="8">
								    <div class="zanzhu-center">江苏象石实业股份有限公司</div>
								</el-col>
								<el-col :span="8">
								    <div class="zanzhu-right">唐山鑫杭钢铁有限公司</div>
								</el-col>
							</el-row>
				        </div>
				    </div>
				</div>
				<div class="meeting-yt">
				    <p class="meeting-yt-title center textCenter t1"><span style="display: inline-block; margin-left: -35px; margin-top: 10px"></span></p>
				    <div class="meeting-address">
				        <div style="margin-top: 40px; color: #8e3837" class="mw-modular-box textCenter">
				            <h3 style="line-height: 40px; font-size: 24px">唐山香格里拉大酒店</h3>
				            <p style="line-height: 40px; font-size:24px">河北省唐山市路北区长虹西道887号、889号</p>
				            <p style="line-height: 40px; font-size:16px">会址距唐山三女河机场约 25分钟车程，距唐山火车站20分钟车程。</p>
				        </div>
				        <div class="address-bg textCenter">
				            <a href="https://map.baidu.com/poi/%E5%94%90%E5%B1%B1%E9%A6%99%E6%A0%BC%E9%87%8C%E6%8B%89%E5%A4%A7%E9%85%92%E5%BA%97/@13152973.355,4790494.665,13z?uid=eb1701ded3c1306d774ff18f&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&newfrom=zhuzhan_webmap&querytype=detailConInfo&da_src=shareurl" target="_blank">
				                <img src="../../assets/images/ej/activity_tangshan2021/address.jpg" alt="" srcset="" class="">
				            </a>
				        </div>
				    </div>
				</div>
				<div class="meeting-yt">
				    <p class="meeting-yt-title center textCenter t2"><span style="display: inline-block; margin-left: -35px; margin-top: 10px"></span></p>
				    <div class="meeting-concat center font16 mt40" style="color: #8e3837">
				        <p class="textCenter" style="line-height: 40px;">
				            河北唐宋大数据产业股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;会务联系人：王慧<br>
				            回执传真至：0315-5921091/92&nbsp;&nbsp;&nbsp;&nbsp;联系方式：18231525225
				        </p>
				        <el-row style="margin-top: 10px; padding-bottom: 30px;">
				            <el-col :span="8">
				                <div class="textCenter">
				                    <img src="../../assets/images/act_code1.png" alt="" width="100px">
				                    <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
				                </div>
				            </el-col>
				            <el-col :span="8">
				                <div class="textCenter">
				                    <img src="../../assets/images/footer_down.png" alt="" width="100px">
				                    <p style="line-height: 35px;">唐宋app</p>
				                </div>
				            </el-col>
				            <el-col :span="8">
				                <div class="textCenter">
				                    <img src="../../assets/images/footer_code.png" alt="" width="100px">
				                    <p style="line-height: 35px;">唐宋大数据</p>
				                </div>
				            </el-col>
				        </el-row>
				    </div>
				</div>
			</div>
			<div v-if="talkTab == 1">
				<div class="ji-jin" id="ji-jin">
					<div class="j-j-title"></div>
					<div class="j-j-content">
						
					</div>
				</div>
				<div class="tong-xue" id="tong-xue">
					<div class="t-x-title"></div>
					<div class="t-x-content">
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/01宋雷.jpg"/>
							<div>
								宋雷
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/常崇斌.jpg"/>
							<div>
								常崇斌
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/董世勇.jpg"/>
							<div>
								董世勇
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/冯智彪.jpg"/>
							<div>
								冯智彪
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/韩伟.jpg"/>
							<div>
								韩伟
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/金凤.jpg"/>
							<div>
								金凤
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/梁润辉.jpg"/>
							<div>
								梁润辉
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/刘鹏.jpg"/>
							<div>
								刘鹏
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/刘瑞.jpg"/>
							<div>
								刘瑞
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/刘姗娜.jpg"/>
							<div>
								刘姗娜
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/刘涛.jpg"/>
							<div>
								刘涛
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/吕秉海.jpg"/>
							<div>
								吕秉海
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/宁心.jpg"/>
							<div>
								宁心
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/任继辉.jpg"/>
							<div>
								任继辉
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/宋加峰.jpg"/>
							<div>
								宋加峰
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/孙亚男.jpg"/>
							<div>
								孙亚男
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/孙岩.jpg"/>
							<div>
								孙岩
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/王春明.jpg"/>
							<div>
								王春明
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/王春艳.jpg"/>
							<div>
								王春艳
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/吴志友.jpg"/>
							<div>
								吴志友
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/谢伟.jpg"/>
							<div>
								谢伟
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/叶会华.jpg"/>
							<div>
								叶会华
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/赵卫卫.jpg"/>
							<div>
								赵卫卫
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/同学会/郑羽佳.jpg"/>
							<div>
								郑羽佳
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="talkTab == 2">
				<div class="tong-xue" id="tong-xue">
					<div class="t-x-title"></div>
					<div class="t-x-content">
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/01宋雷.jpg"/>
							<div>
								宋雷
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/崔行.jpg"/>
							<div>
								崔行
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/迪林.jpg"/>
							<div>
								迪林
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/何洪涛.jpg"/>
							<div>
								何洪涛
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/李志强.jpg"/>
							<div>
								李志强
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/刘士友.jpg"/>
							<div>
								刘士友
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/刘艳丽.jpg"/>
							<div>
								刘艳丽
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/刘洋.jpg"/>
							<div>
								刘洋
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/王立刚.jpg"/>
							<div>
								王立刚
							</div>
						</div>
						<div class="t-x-c-item">
							<img src="../../assets/images/2022nianhui/钢坯分会场/张海东.jpg"/>
							<div>
								张海东
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="talkTab == 3">
				<div style="display: flex;justify-content: center;margin-top: 80px;">
					<el-carousel :interval="4000" type="card" style="width: 1200px;">
					    <el-carousel-item v-for="(item, index) in shijiaImgs" :key="index">
							<el-image :src="item" style="width: 600px;"/>
					    </el-carousel-item>
					  </el-carousel>
				</div>
				<div class="shi-jia" id="shi-jia">
					<div class="s-j-title"></div>
					
					<div class="s-j-content">
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳钢铁生产企业
							</div>
							<div class="s-j-i-i">
								河北津西钢铁集团股份有限公司<br/>
								天津市新天钢联合特钢有限公司<br/>
								唐山东华钢铁企业集团有限公司<br/>
								陕西钢铁集团有限公司<br/>
								秦皇岛宏兴钢铁有限公司<br/>
								山西建邦集团有限公司<br/>
								天津荣程联合钢铁集团有限公司<br/>
								河北安丰钢铁集团有限公司<br/>
								山东泰山钢铁集团有限公司<br/>
								山西晋南钢铁集团有限公司<br/>
							</div>
						</div>
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳钢加工企业
							</div>
							<div class="s-j-i-i">
								秦皇岛顺先钢铁有限公司<br/>
								临沂合力钢材有限公司<br/>
								唐山首唐宝生功能材料有限公司<br/>
								天津晁权实业有限公司<br/>
								唐山如隆实业有限公司<br/>
								唐山市尊信科技有限公司<br/>
								唐山市丰润区达亿板带加工有限公司<br/>
								天津市仁通钢铁有限公司<br/>
								泰安市鲁阳金属制品有限公司<br/>
								庆云华兴钢架工程有限公司<br/>
							</div>
						</div>
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳钢管制造企业
							</div>
							<div class="s-j-i-i">
								防城港天地和金属制品有限公司<br/>
								新绛天地和金属制品有限公司<br/>
								天津友发钢管集团股份有限公司<br/>
								河北盛泰制管有限公司<br/>
								天津市宝来工贸有限公司<br/>
								天津源泰德润钢管制造集团有限公司<br/>
								天津市増洋钢铁有限公司<br/>
								天津市利达钢管集团有限公司<br/>
								邯郸正大制管集团股份有限公司<br/>
								河北天创新材料科技有限公司<br/>
							</div>
						</div>
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳焦化生产企业
							</div>
							<div class="s-j-i-i">
								唐山东方炼焦制气有限公司<br/>
								金鼎钢铁集团煤焦化有限公司<br/>
								唐山达丰焦化有限公司<br/>
								河北华丰能源科技发展有限公司<br/>
								山西焦化集团有限公司<br/>
								旭阳集团有限公司<br/>
								山西亚鑫能源集团有限公司<br/>
								山西鹏飞集团有限公司<br/>
								山西安泰集团股份有限公司<br/>
								山西美锦能源股份有限公司<br/>
							</div>
						</div>
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳废钢回收加工企业
							</div>
							<div class="s-j-i-i">
								天津德天再生资源利用有限公司<br/>
								曲靖市马龙区豪杰再生资源回收有限公司<br/>
								天津璟晟再生资源利用有限公司<br/>
								扬州鸿蓝钢铁加工有限公司<br/>
								天津振泓再生资源有限公司<br/>
								河北联港废钢铁回收有限公司<br/>
								迁安聚力再生资源回收有限公司<br/>
								滦县首龙通力再生资源利用有限公司<br/>
								唐山富鑫再生资源有限公司<br/>
								秦皇岛环盛炉料有限公司<br/>
							</div>
						</div>
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳钢铁综合贸易企业
							</div>
							<div class="s-j-i-i">
								厦门建发金属有限公司<br/>
								德天（天津） 国际贸易发展有限公司<br/>
								杭州杭钢对外经济贸易有限公司<br/>
								苏美达国际技术贸易有限公司<br/>
								江苏象石实业股份有限公司<br/>
								中航国际钢铁贸易有限公司<br/>
								唐山凯荣国际贸易有限公司<br/>
								物产中大金属集团有限公司<br/>
								浙商中拓集团股份有限公司<br/>
								浙江杭钢国贸有限公司<br/>
							</div>
						</div>
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳期货企业
							</div>
							<div class="s-j-i-i">
								平安期货有限公司<br/>
								银河期货有限公司<br/>
								中辉期货有限公司<br/>
								永安期货股份有限公司<br/>
								上海东亚期货有限公司<br/>
								国海良时期货有限公司<br/>
								上海东证期货有限公司<br/>
								国投安信期货有限公司<br/>
								中泰期货股份有限公司天津营业部<br/>
								中电投先融期货股份有限公司<br/>
							</div>
						</div>
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳钢铁物流企业
							</div>
							<div class="s-j-i-i">
								河北连盈国际物流有限公司<br/>
								唐山市双赢物流有限公司<br/>
								唐山东方海运有限公司<br/>
								物产中大物流投资集团有限公司唐山分公司<br/>
								唐山象屿正丰国际物流有限公司<br/>
								唐山海盈国际物流有限公司<br/>
								唐山连盈国际物流有限公司<br/>
								唐山海翼宏润物流有限公司<br/>
								邯郸新铁物流有限公司<br/>
								唐山市丰南区永昌物流有限公司<br/>
							</div>
						</div>
						<div class="s-j-item">
							<div class="s-j-i-title">
								十佳服务企业
							</div>
							<div class="s-j-i-i">
								德邻陆港供应链服务有限公司<br/>
								中琉科技有限公司<br/>
								钢谷电子商务股份有限公司<br/>
								北京盛裕成科技发展有限公司<br/>
								中联钢信电子商务有限公司<br/>
								紫中普世(北京)科技发展有限公司<br/>
								上海金仕达软件科技股份有限公司<br/>
								唐山和平钢铁物流有限公司<br/>
								山西晋南云钢科技有限公司<br/>
								G7易流<br/>
							</div>
						</div>
					</div>
				</div>
				
				<div style="display: flex;justify-content: center;margin-top: 80px;">
					<el-carousel :interval="4000" type="card" style="width: 1200px;">
					    <el-carousel-item v-for="(item, index) in baiqiangImgs" :key="index">
							<el-image :src="item" style="width: 600px;"/>
					    </el-carousel-item>
					  </el-carousel>
				</div>
				
				<div class="bai-qiang" id="bai-qiang">
					<div class="b-q-title"></div>
					<div class="b-q-content">
						<div class="b-q-item">
							<div class="b-q-i-i">
								中国矿产有限责任公司<br/>
								唐山宏腾贸易有限公司<br/>
								唐山市丰润区超翼商贸有限公司<br/>
								河北港济实业有限公司<br/>
								宁波浮沉矿业有限公司<br/>
								天津龙新科技有限公司<br/>
								天津瑞鑫昌科技有限公司<br/>
								唐山市双盈工贸有限公司<br/>
								青岛喜盈顺供应链管理有限公司<br/>
								山东港中钢铁有限公司<br/>
								唐山永联国际贸易有限责任公司<br/>
								山西新泰富安新材有限公司<br/>
								江苏艾士腾国际贸易有限公司<br/>
								 山东恩光新材料有限公司<br/>
								天津昕田管道科技有限公司<br/>
								天津汇来国际贸易有限公司<br/>
								唐山市晨丰商贸有限公司<br/>
								南京友发物资有限公司<br/>
								河南大道至简钢铁有限公司<br/>
								唐山子实承业钢铁销售有限公司<br/>
								河北华贸电力新材料有限公司<br/>
								天津市呈宇工贸有限公司<br/>
								天津联丰实业有限公司<br/>
								唐山淘钢电子商务有限公司<br/>
								唐山东钢贸易有限公司<br/>
								浙江江丰股份有限公司<br/>
								天津市宏智金属材料有限公司<br/>
								浙江开迪贸易有限公司<br/>
								闽隆电子商务有限公司<br/>
								河南物产集团有限公司<br/>
								成大物产（厦门）有限公司<br/>
								天津中拓电子商务有限公司<br/>
								上海唐汉投资发展有限公司<br/>
								上海瀛环国际贸易有限公司<br/>
							</div>
						</div>
						<div class="b-q-item">
							<div class="b-q-i-i">
								顺富供应链（上海）有限公司<br/>
								无锡市启升金属材料有限公司<br/>
								天津市坤鹏兴达钢管销售有限公司<br/>
								唐山桐宁贸易有限公司<br/>
								山西浩正鸿瑞贸易有限公司<br/>
								唐山市坤宏浩宇国际贸易有限公司<br/>
								唐山市丰润区红樱桃商贸有限公司<br/>
								唐山市金唐伟钢铁有限公司<br/>
								唐山来汇商贸有限公司<br/>
								宁波惠昌贸易有限公司<br/>
								唐山和方实业有限公司<br/>
								天津文安国际贸易有限公司<br/>
								天津市鹏泽贸易有限公司<br/>
								唐山曹妃甸茂华商贸有限公司<br/>
								易大宗（北京）供应链管理有限公司<br/>
								北京中鑫汇达商贸有限公司<br/>
								沈阳盛联钢铁贸易有限公司<br/>
								唐山集荣贸易有限公司<br/>
								山西骞宇物资有限公司<br/>
								辽宁紫中供应链有限责任公司<br/>
								青岛九州物资有限公司<br/>
								天津盛泽工贸有限公司<br/>
								广东荣钢管道科技有限公司<br/>
								佛山市潮博物资有限公司<br/>
								合肥新枫叶物资有限公司<br/>
								岚县长鸿煤业有限公司<br/>
								青岛金广益国际贸易有限公司<br/>
								唐山市丰润区晟豪贸易有限公司<br/>
								唐山连创实业有限公司<br/>
								北京来巍国际贸易有限公司<br/>
								泰州市新发电子商务有限公司<br/>
								武汉华澳物资有限公司<br/>
								唐山朗乾电子商务有限公司<br/>
							</div>
						</div>
						<div class="b-q-item">
							<div class="b-q-i-i">
								天津市宝利钢铁有限公司<br/>
								天津市盛祥昌商贸有限公司<br/>
								哈尔滨多尚经贸有限公司<br/>
								浙江同辉钢铁贸易有限公司<br/>
								杭州成桓钢铁有限公司<br/>
								宁夏晟晏实业集团有限公司<br/>
								河北启信国际贸易有限公司<br/>
								青岛尧舜矿业有限公司<br/>
								苏州同熙机电有限公司<br/>
								唐山汇云商贸有限公司<br/>
								浙江玖衡贸易有限责任公司<br/>
								任丘市超喜钢材销售有限公司<br/>
								唐山百优贸易有限公司<br/>
								北京恒洋通业商贸有限公司<br/>
								青县冀通钢材销售有限公司<br/>
								芜湖鑫正锋钢材贸易有限公司<br/>
								浙江正统钢业有限公司<br/>
								鞍山市鑫华通贸易有限公司<br/>
								唐山和朋贸易有限公司<br/>
								天津景旺盛兴钢铁贸易有限公司<br/>
								唐山承起钢铁科技有限公司<br/>
								杭州国祝联成实业有限公司<br/>
								天津杰锋钢管工贸有限公司<br/>
								天津众鋆国际贸易有限公司<br/>
								天津金丰亨达钢铁贸易有限公司<br/>
								天津津路钢铁实业有限公司<br/>
								日照昱丰贸易有限公司<br/>
								唐山迪宏国际贸易有限公司<br/>
								天津市德健钢管有限公司<br/>
								天津市鑫保利商贸有限公司<br/>
								唐山冠石国际贸易有限公司<br/>
								河北博业贸易集团有限公司<br/>
								中基宁波集团股份有限公司<br/>
							</div>
						</div>
					</div>
				</div>
			</div>
        </article>

        <div v-if="talkTab == 0" class="fix-box">
			<div class="f-b-i i1" @click="scrollInto('zhu-ti')">
				主题<br/>演讲
			</div>
			<div class="f-b-i i2" @click="scrollInto('gao-duan')">
				高端<br/>访谈
			</div>
			<div class="f-b-i i3" @click="scrollInto('zhan-lue')">
				签约<br/>仪式
			</div>
			<div class="f-b-i i4" @click="scrollInto('chou-jiang')">
				抽奖<br/>集锦
			</div>
		</div>
    </div>
</template>
<script>

/*{
"img": "https://tangsong.chinatsi.net/static/billetzs/images/20211213/20211213133021965595.jpg",
"title": "2021年钢铁产业年终论坛暨中国钢铁产业网年会",
"oprator": "河北唐宋大数据产业股份有限公司、熔冶（北京）钢铁工业研究院、中国（河北）自由贸易试验区曹妃甸片区管理委员会联合主办",
"time": "2021年12月9-10日",
"address": "唐山香格里拉大酒店",
"members": "200",
"id": 7
},*/

import $ from 'jquery'
import QRCode from 'qrcode'
import '../../assets/js/jquery.liMarquee.js'
import { baseUrl, getQueryString, adIDs } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'activitiesDetail2021ts',
    components: { ConcatsControl },
    data() {
        return {
            adIDsIndex: [{
                name: 'zx39',
                id: adIDs['zx39'],
                list: []
            }],
            liMarquee: null,
            dialogVisible: false,
            dialogImg: '',
            imgs: [
                require('../../assets/images/ej/activity_tangshan2021/sj_bancai.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_daigang.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_fuwu.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangguan.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangguanzhizao.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangjiegoushengchan.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangpi.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangtiejiagong.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangtiemaoyi.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangtieshengchan.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_gangtiewuliu.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_jiancai.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_jiaohua.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_meijiao.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_qihuo.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_tiekuangshi.jpg'),
                require('../../assets/images/ej/activity_tangshan2021/sj_xinggang.jpg')
            ],
			shijiaImgs: [
				require('../../assets/images/2022nianhui/百强/1.png'),
				require('../../assets/images/2022nianhui/百强/2.png'),
				require('../../assets/images/2022nianhui/百强/3.png'),
				require('../../assets/images/2022nianhui/百强/4.png'),
				require('../../assets/images/2022nianhui/百强/5.png'),
				require('../../assets/images/2022nianhui/百强/6.png'),
				require('../../assets/images/2022nianhui/百强/7.png'),
				require('../../assets/images/2022nianhui/百强/8.png'),
				require('../../assets/images/2022nianhui/百强/9.png')
			],
			baiqiangImgs: [
				require('../../assets/images/2022nianhui/百强/10.png'),
				require('../../assets/images/2022nianhui/百强/11.png'),
				require('../../assets/images/2022nianhui/百强/12.png'),
			],
            imgsDetailNames: [
                // ['河北普阳钢铁有限公司', '河北津西钢铁集团股份有限公司', '秦皇岛宏兴钢铁有限公司', '唐山市德龙钢铁有限公司', '山西晋南钢铁集团有限公司', '河北天柱钢铁集团有限公司', '天津荣程联合钢铁集团有限公司', '唐山东华钢铁企业集团有限公司', '河北安丰钢铁有限公司', '江苏徐钢钢铁集团有限公司'], // 钢铁生产企业
                // ['厦门海翼国际贸易有限公司', '浙江物产金属集团有限公司', '中基宁波集团股份有限公司', '成大物产（厦门）有限公司', '浙商中拓集团股份有限公司', '山东天保工贸有限公司', '天津启润投资有限公司', '苏美达国际技术贸易有限公司', '杭州热联集团股份有限公司', '江苏象石实业股份有限公司'], // 综合贸易企业
                // ['新绛天地和金属制品有限公司', '天津市群胜达钢管有限公司', '天津友发钢管集团股份有限公司', '山东舜世高科实业有限公司', 'ZDP正大制管有限公司', '霸州市众丰金属制品有限公司', '天津市可楠钢管有限公司', '天津市宝来工贸有限公司', '河北盛泰制管有限公司', '天津市利达钢管集团有限公司'], // 钢管制造企业
                // ['唐山海翼宏润物流有限公司', '浙江物产物流投资有限公司唐山分公司', '厦门国贸启铭物流有限公司', '唐山市丰领物流有限公司', '四川乐送物流股份有限公司', '河北兴泰物流有限公司', '唐山象屿正丰国际物流有限公司', '唐山市双赢物流有限公司', '邯郸新铁物流有限公司', '唐山东方海运有限公司'], // 钢铁物流企业
                // ['唐山友利焦化有限公司', '武安市广普焦化有限公司', '介休市昌盛煤气化有限公司', '山西安泰集团股份有限公司', '唐山东方炼焦制气有限公司', '乌海市广纳煤焦化有限公司', '河北华丰能源科技发展有限公司', '山西潞宝集团焦化有限公司', '唐山达丰焦化有限公司', '山西亚鑫煤焦化有限公司'], // 焦化生产企业
                // ['秦皇岛顺先钢铁有限公司', '天津市震翔板带加工有限公司', '唐山市丰润区鸿翔金属制品有限公司', '唐山首唐宝生功能材料有限公司', '唐山如隆实业有限公司', '唐山市丰润区鑫通源扁钢厂', '唐山宏润实业有限公司', '唐山市德物精密制品有限公司 ', '江苏卓群金属科技有限公司', '唐山市丰润区永强轧钢厂'], //钢加工企业
                // ['河北津西新材料科技有限公司', '泊头市宝发彩钢钢构工程有限公司', '庆云华兴钢架工程有限公司', '宏德瑞琳金属结构制造有限公司', '邯郸市银蝉贸易有限公司', '潍坊长安铁塔股份有限公司', '天津市鑫跃达工贸有限公司', '邯郸市泽业贸易有限公司', '邯郸市恒特板材加工有限公司', '邯郸市华威钢结构工程有限公司'], // 钢结构生产企业
                // ['本溪市远通物资回收有限公司', '朝阳议通金属再生资源有限公司', '天津城矿再生资源回收有限公司', '武安市永鑫再生资源利用有限公司', '天津德邦（邢台县）再生资源利用有限公司', '扬州鸿蓝钢铁加工有限公司', '天津振泓再生资源有限公司', '天津宏业兴再生物资回收有限公司', '浙商中拓集团江西再生资源有限公司', '河南冀物再生资源有限公司'], // 废钢回收加工企业
                // ['上海东亚期货有限公司', '中辉期货有限公司', '宏源期货有限公司', '徽商期货有限责任公司', '永安期货股份有限公司', '国投安信期货有限公司', '国泰君安期货有限公司', '银河期货有限公司', '国海良时期货有限公司', '中国国际期货股份有限公司'], // 期货企业
                // ['辽宁海力特种石油装备有限公司', '上海鸿网供应链股份有限公司', '中国检验认证集团河北有限公司', '钢谷电子商务股份有限公司', '德邻智联（鞍山）有限公司', '日照大宗商品交易中心', '中瑞和（天津）供应链管理服务有限公司', '唐山曹妃甸实业港务有限公司', '北京恒润九州实业有限公司', '秦皇岛佰工钢铁有限公司'], // 服务企业
                // ['厦门国贸集团股份有限公司', '唐山凯荣国际贸易有限公司', '中航国际钢铁贸易有限公司', '天津锦亿供应链管理有限公司', '嘉吉投资（中国）有限公司', '浙江物产金属集团有限公司', '河钢集团北京国际贸易有限公司', '山东建邦联合进出口有限公司', '山东环富国际贸易有限公司', '日照兴业集团有限公司'], //铁矿石供应商
                // ['唐山和朋贸易有限公司', '山东中垠国际贸易有限公司', '唐山永联国际贸易有限责任公司', '山东冀中瀚能供应链管理有限公司', '唐山市五山商贸有限公司', '厦门象屿股份有限公司', '易大宗（北京）供应链管理有限公司', '山东潍焦集团薛城能源有限公司', '山西省焦炭集团经销贸易有限公司', '重庆喜丰春瑞供应链管理有限公司'], // 煤焦供应商
                // ['天津瑞鑫昌科技有限公司', '河北港济实业有限公司', '河北港禾实业发展有限公司', '浙江开迪贸易有限公司', '江阴市铁实供应链有限公司', '上海俱丰供应链有限公司', '迁安市瑞虎商贸有限公司', '唐山市晨丰商贸有限公司', '天津市仁通钢铁有限公司', '唐山海瀚国际贸易有限公司'], // 钢坯供应商
                // ['唐山市丰润区乔羽贸易有限公司', '山西浩正鸿瑞贸易有限公司', '河北华贸电力新材料有限公司', '宁波荣城金属材料有限公司', '鞍山市鑫华通贸易有限公司', '唐山市丰润区超翼商贸有限公司', '邯郸市裕驰贸易有限公司', '泰安市延峰物资有限公司', '唐山市丰润区建源商贸有限公司', '唐山朗威进出口贸易有限公司'], // 型钢供应商
                // ['汇金工贸（天津）有限公司', '邯郸市钢盈贸易有限公司', '山东新乐华钢铁有限公司', '青岛鸿利宇供应链有限公司', '邯郸市泰虎贸易有限公司', '河北邯城贸易有限公司', '河北泰岳峰钢铁贸易有限公司', '唐山市炳旭实业有限公司', '中船重工物资贸易集团有限公司', '邯郸市晟德贸易有限公司'], // 板材供应商
                // ['辽宁紫中供应链有限责任公司', '河南豫之钢贸易有限公司', '万豪钢铁集团有限公司', '任丘市亚丰建筑器材有限公司', '中铁铁龙（营口）国际物流贸易有限公司', '唐山宏腾贸易有限公司', '陕钢集团韩城钢铁有限责任公司', '福建点增贸易有限公司', '山西兴合邦物资有限公司', '山东蓝天新材料科技有限公司'], // 建材供应商
                // ['天津市仁翼博爱国际商贸有限公司', '无锡市启升金属材料有限公司', '天津市宏英丰达金属材料销售有限公司', '瑞信国际贸易有限公司', '天津市智恒达商贸有限公司', '迁安市瑞虎商贸有限公司', '天津市丰隆商贸有限公司', '天津中拓电子商务有限公司', '上海塔杰实业有限公司', '天津勤兴敬业科技有限公司'], // 带钢供应商
                // ['天津市民阁商贸有限公司', '广州市华利丰钢材贸易有限公司', '南京友发物资有限公司', '奎鑫钢首集团', '唐山市青坤贸易有限公司', '霸州市广义制管有限公司', '天津海翼钢铁销售有限公司', '天津德汇钢铁贸易有限公司', '天津宏盛强钢铁有限公司', '天津市德健钢管有限公司'], // 钢管供应商
            ],
            sjDetailData: [],
            talkTab: 0,
			scrollTop: 0
        }
    },
    mounted () {
		var temp = this
        this.id = getQueryString('id');
        this.getAdByAdp();
        this.marqueeInit();
		
		window.addEventListener('scroll', function() {
			temp.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		}, false)
    },
    methods: {
		scrollInto(id) {
			var element = document.getElementById(id);
			element.scrollIntoView();
		},
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        marqueeInit () {
            const self = this;
            $('.index-quote-list-box').liMarquee('destroy');
            setTimeout(() => {
                $('.index-quote-list-box').liMarquee({
                    // direction: 'up',
                    // loop: -1,
                    scrollamount: 30,
                    hoverstop: true,
                    circular: false
                });
            }, 500)
            
            
        },
        showImgDetail (index) {
            // console.log('进来了')
            this.dialogImg = this.imgs[index];
            // this.sjDetailData = this.imgsDetailNames[index];
            this.dialogVisible = true;
        },
        changeTalkTab (tab) {
            this.talkTab = tab;
        }
    }
    
}
</script>

<style scoped>
    @import url('../../assets/css/liMarquee.css');
    .content-bg {
        width: 100%;
    }
	.content-bg-c {
	    background: url('../../assets/images/2022nianhui/top.jpg') no-repeat;
	    background-size: 100% auto;
	    position: relative;
	    background-size: cover;
	    background-position: 50% 0%;
	    background-repeat: no-repeat;
		height: 872px;
		width: 100%;
	}
	.short-cut {
		background: url('../../assets/images/2022nianhui/企业简介BG.jpg') no-repeat;
		background-size: 100% auto;
		position: relative;
		background-size: cover;
		background-position: 50% 0%;
		background-repeat: no-repeat;
		height: 472px;
		width: 100%;
		
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.short-cut-bg {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px;
		height: 360px;
		background-color: #FFFFFF;
		border-radius: 8px;
		box-sizing: border-box;
	}
	.s-c-left {
		width: 600px;
		height: 320px;
		background: url('https://interface.chinatsi.net/static/minifolder/2023022010041273221796_2023020810235073220472_微信图片_20230208102249.jpg') no-repeat;
		background-size: cover;
		background-position: 50% 80%;
	}
	.s-c-right {
		width: 540px;
		height: 360px;
		margin-top: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-direction: column;
	}
	.s-c-title {
		font-size: 28px;
		color: #e71b00;
		font-weight: bold;
		margin-bottom: 20px;
	}
	.s-c-content {
		font-size: 18px;
		color: #333333;
		font-weight: normal;
	}
	.zhu-ti {
		width: 100%;
		display: flex;
		justify-content: center;
		flex-direction: column;
	}
	.z-t-title {
		height: calc(163px * 0.7);
		background: url('../../assets/images/2022nianhui/主题演讲标签.jpg') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
		background-color: #f7f7f7;
	}
	.z-t-content {
		margin-left: calc(50% - 600px);
		margin-top: 40px;
		width: 1200px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	.z-t-c-item {
		width: 280px;
		height: 160px;
		margin-bottom: 72px;
		position: relative;
	}
	.z-t-c-item.t1 {
		background: url('../../assets/images/2022nianhui/主题演讲/1.jpg') no-repeat;
	}
	.z-t-c-item.t2 {
		background: url('../../assets/images/2022nianhui/主题演讲/2.jpg') no-repeat;
	}
	.z-t-c-item.t3 {
		background: url('../../assets/images/2022nianhui/主题演讲/3.jpg') no-repeat;
	}
	.z-t-c-item.t4 {
		background: url('../../assets/images/2022nianhui/主题演讲/4.jpg') no-repeat;
	}
	.z-t-c-item.t5 {
		background: url('../../assets/images/2022nianhui/主题演讲/5.jpg') no-repeat;
	}
	.z-t-c-item.t6 {
		background: url('../../assets/images/2022nianhui/主题演讲/6.jpg') no-repeat;
	}
	.z-t-c-item.t7 {
		background: url('../../assets/images/2022nianhui/主题演讲/7.jpg') no-repeat;
	}
	.z-t-c-item.t8 {
		background: url('../../assets/images/2022nianhui/主题演讲/8.jpg') no-repeat;
	}
	.z-t-c-item-name {
		position: absolute;
		left: 12px;
		top: 16px;
		font-size: 14px;
		background-color: rgba(0, 0, 0, 0.4);
		color: #FFFFFF;
		padding: 4px 16px;
		border-radius: 4px;
	}
	.z-t-c-item-title {
		position: absolute;
		width: 280px;
		bottom: 16px;
		text-align: center;
		font-size: 16px;
		color: #FFFFFF;
	}
	.z-t-c-item-post {
		position: absolute;
		width: 280px;
		bottom: -26px;
		text-align: center;
		color: #333333;
		font-size: 14px;
		font-weight: bold;
	}
	.gao-duan {
		background: url('../../assets/images/2022nianhui/高端访谈BG.jpg') no-repeat;
		background-size: 100% auto;
		position: relative;
		background-size: cover;
		background-position: 50% 0%;
		background-repeat: no-repeat;
		height: calc(716px);
		width: 100%;
		box-sizing: border-box;
		border-top: 1px solid #FFFFFF;
		
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.g-d-title {
		width: calc(1176px / 2);
		height: calc(163px * 0.7);
		background: url('../../assets/images/2022nianhui/市场高端访谈标签.jpg') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
	}
	.g-d-content {
		width: 1012px;
		height: 342px;
		background: url('../../assets/images/2022nianhui/bg_customer_texure.jpg') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
		margin-top: 60px;
		position: relative;
	}
	.g-d-logo {
		width: 215px;
		height: 25px;
		background: url('../../assets/images/2022nianhui/tslogo.png') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
		margin-top: 30px;
		margin-left: 240px;
	}
	.g-d-tstitle {
		position: relative;
		font-size: 22px;
		margin-left: 64px;
		margin-top: 24px;
		margin-bottom: 12px;
	}
	.g-d-tstitle::before {
		display: inline-block;
		width: 39px;
		height: 29px;
		content: "";
		background: url('../../assets/images/2022nianhui/double.png') no-repeat;
		position: absolute;
		top: 4px;
		left: -48px;
	}
	.g-d-tscontent {
		font-size: 18px;
		margin-top: 4px;
		margin-left: 64px;
	}
	.g-d-tspost {
		font-size: 18px;
		margin-top: 96px;
		margin-left: 64px;
	}
	.g-d-picture {
		position: absolute;
		width: 320px;
		height: 272px;
		right: 32px;
		top: 32px;
		background-color: #282828;
	}
	.g-d-picture .t1 {
		height: 272px;
		background: url('../../assets/images/2022nianhui/高端访谈/1.jpg') no-repeat;
	}
	.g-d-picture .t2 {
		height: 272px;
		background: url('../../assets/images/2022nianhui/高端访谈/2.jpg') no-repeat;
	}
	.g-d-picture .t3 {
		height: 272px;
		background: url('../../assets/images/2022nianhui/高端访谈/3.jpg') no-repeat;
	}
	.g-d-picture .t4 {
		height: 272px;
		background: url('../../assets/images/2022nianhui/高端访谈/4.jpg') no-repeat;
	}
	.g-d-picture .t5 {
		height: 272px;
		background: url('../../assets/images/2022nianhui/高端访谈/5.jpg') no-repeat;
	}
	.g-d-picture .t6 {
		height: 272px;
		background: url('../../assets/images/2022nianhui/高端访谈/6.jpg') no-repeat;
	}
	.g-d-picture .t7 {
		height: 272px;
		background: url('../../assets/images/2022nianhui/高端访谈/7.jpg') no-repeat;
	}
	.g-d-picture .t8 {
		height: 272px;
		background: url('../../assets/images/2022nianhui/高端访谈/8.jpg') no-repeat;
	}
	.zhan-lue {
		background: #f7f7f7;
		background-size: 100% auto;
		position: relative;
		background-size: cover;
		background-position: 50% 0%;
		background-repeat: no-repeat;
		height: calc(576px);
		width: 100%;
		box-sizing: border-box;
		border-top: 1px solid #FFFFFF;
		
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.z-l-title {
		width: calc(526px);
		height: calc(163px * 0.7);
		background: url('../../assets/images/2022nianhui/战略合作签约.png') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
	}
	.z-l-content {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		margin-top: 48px;
	}
	.z-l-c-item {
		width: 380px;
		height: 260px;
		border-radius: 4px;
		background-size: 380px 260px;
		background-position: 50% 50%;
	}
	.z-l-c-item.t1 {
		background-image: url('../../assets/images/2022nianhui/签约仪式/1.jpg');
	}
	.z-l-c-item.t2 {
		background-image: url('../../assets/images/2022nianhui/签约仪式/2.jpg');
	}
	.z-l-c-item.t3 {
		background-image: url('../../assets/images/2022nianhui/签约仪式/3.jpg');
	}
	.chou-jiang {
		background: #f7f7f7;
		background-size: 100% auto;
		position: relative;
		background-size: cover;
		background-position: 50% 0%;
		background-repeat: no-repeat;
		height: calc(644px);
		width: 100%;
		box-sizing: border-box;
		border-top: 1px solid #FFFFFF;
		
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.c-j-title {
		width: calc(519px * 0.8);
		height: calc(163px * 0.7);
		background: url('../../assets/images/2022nianhui/抽奖标签.png') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
	}
	.c-j-content {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		margin-top: 48px;
		flex-wrap: wrap;
	}
	.c-j-c-item {
		width: 280px;
		height: 200px;
		border-radius: 4px;
		margin-bottom: 32px;
	}
	.c-j-c-item.t1 {
		background-image: url('../../assets/images/2022nianhui/抽奖集锦/1.jpg');
	}
	.c-j-c-item.t2 {
		background-image: url('../../assets/images/2022nianhui/抽奖集锦/2.jpg');
	}
	.c-j-c-item.t3 {
		background-image: url('../../assets/images/2022nianhui/抽奖集锦/3.jpg');
	}
	.c-j-c-item.t4 {
		background-image: url('../../assets/images/2022nianhui/抽奖集锦/4.jpg');
	}
	.c-j-c-item.t5 {
		background-image: url('../../assets/images/2022nianhui/抽奖集锦/5.jpg');
	}
	.c-j-c-item.t6 {
		background-image: url('../../assets/images/2022nianhui/抽奖集锦/6.jpg');
	}
	.c-j-c-item.t7 {
		background-image: url('../../assets/images/2022nianhui/抽奖集锦/7.jpg');
	}
	.c-j-c-item.t8 {
		background-image: url('../../assets/images/2022nianhui/抽奖集锦/8.jpg');
	}
	
	.ji-jin {
		background: #f7f7f7;
		background-size: 100% auto;
		position: relative;
		background-size: cover;
		background-position: 50% 0%;
		background-repeat: no-repeat;
		width: 100%;
		box-sizing: border-box;
		border-top: 1px solid #FFFFFF;
		padding-top: 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-top: 80px;
	}
	
	.j-j-title {
		width: calc(526px);
		height: calc(163px * 0.7);
		background: url('../../assets/images/2022nianhui/同学会/同学会锦集标签.png') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
	}
	
	.j-j-content {
		width: 1200px;
		height: 700px;
		display: flex;
		justify-content: space-between;
		margin-top: 48px;
		flex-wrap: wrap;
		background: url('../../assets/images/2022nianhui/同学会/锦集图片.jpg') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
	}
	
	.tong-xue {
		background: #f7f7f7;
		background-size: 100% auto;
		position: relative;
		background-size: cover;
		background-position: 50% 0%;
		background-repeat: no-repeat;
		width: 100%;
		box-sizing: border-box;
		border-top: 1px solid #FFFFFF;
		padding-top: 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-top: 80px;
		padding-bottom: 80px;
	}
	
	.t-x-title {
		width: calc(526px);
		height: calc(163px * 0.7);
		background: url('../../assets/images/2022nianhui/同学会/学员介绍标签.png') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
	}
	
	.t-x-content {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		margin-top: 48px;
		flex-wrap: wrap;
	}
	
	.t-x-c-item {
		width: 380px;
		background-color: #FFFFFF;
		padding: 20px;
		margin-top: 20px;
		box-sizing: border-box;
	}
	
	.t-x-c-item img {
		width: 340px;
	}
	
	.t-x-c-item div {
		font-size: 18px;
		text-align: center;
		margin-top: 16px;
	}
	
	.shi-jia {
		background: #f7f7f7;
		background-size: 100% auto;
		position: relative;
		background-size: cover;
		background-position: 50% 0%;
		background-repeat: no-repeat;
		width: 100%;
		box-sizing: border-box;
		border-top: 1px solid #FFFFFF;
		padding-top: 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.s-j-title {
		width: calc(526px);
		height: calc(163px * 0.7);
		background: url('../../assets/images/2022nianhui/十佳标签.png') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
	}
	.s-j-content {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		margin-top: 48px;
		flex-wrap: wrap;
	}
	.s-j-item {
		width: 380px;
		margin-bottom: 32px;
	}
	.s-j-i-title {
		font-size: 24px;
		color: #333333;
		position: relative;
		padding-left: 18px;
		font-weight: bold;
	}
	.s-j-i-title::before {
		display: inline-block;
		content: "";
		background-color: rgb(251, 65, 72);
		width: 8px;
		height: 32px;
		position: absolute;
		top: 0px;
		left: 0px;
	}
	.s-j-i-i {
		margin-top: 20px;
		line-height: 40px;
		font-size: 20px;
	}
	
	.bai-qiang {
		background: #f7f7f7;
		background-size: 100% auto;
		position: relative;
		background-size: cover;
		background-position: 50% 0%;
		background-repeat: no-repeat;
		width: 100%;
		box-sizing: border-box;
		border-top: 1px solid #FFFFFF;
		padding-top: 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.b-q-title {
		width: calc(526px);
		height: calc(163px * 0.7);
		background: url('../../assets/images/2022nianhui/百强标签.png') no-repeat;
		background-size: contain;
		background-position: 50% 50%;
	}
	.b-q-content {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		margin-top: 48px;
		flex-wrap: wrap;
	}
	.b-q-item {
		width: 380px;
		margin-bottom: 32px;
	}
	.b-q-i-title {
		font-size: 24px;
		color: #333333;
		position: relative;
		padding-left: 18px;
		font-weight: bold;
	}
	.b-q-i-title::before {
		display: inline-block;
		content: "";
		background-color: rgb(251, 65, 72);
		width: 8px;
		height: 32px;
		position: absolute;
		top: 0px;
		left: 0px;
	}
	.b-q-i-i {
		margin-top: 20px;
		line-height: 40px;
		font-size: 20px;
	}
	
	.fix-box {
		position: fixed;
		z-index: 9999;
		bottom: 120px;
		right: calc(50vw - 600px - 120px);
		box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.5);
		width: 80px;
		text-align: center;
		border-radius: 8px;
		padding-top: 20px;
		padding-bottom: 20px;
		background-color: #FFFFFF;
	}
	
	.f-b-i {
		font-size: 20px;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	
	.f-b-i:hover {
		cursor: pointer;
	}
	
	.f-b-i::after {
		display: inline-block;
		content: '';
		width: 60px;
		border-bottom: rgb(233, 233, 233) 1px solid;
	}
	
	.f-b-i:last-child::after {
		display: none;
	}
	
    .logo-position {
        position: absolute;
        top: 60px;
        left: 60px;
        color: #fff;
    }
    .logo-position > p { font-size: 20px; }
    .logo-position > div > span { display: inline-block; margin-bottom: 20px; width: 8px; border-top: 2px solid #fff;}
    .mt10 { margin-top: 10px; }
    .mt40 { margin-top: 40px; }
    .mt30 { margin-top: 30px; }
    .mb15 { margin-bottom: 15px; }
    .title-text { font-size: 28px; letter-spacing: 10px; }
    .title-text-en { font-size: 20px; letter-spacing: 4px; font-weight: 100;}
    .time-text { 
        background: url('../../assets/images/ej/activeTimebg.png') no-repeat; 
        background-size: 100% 100%;
        line-height: 40px;
        width: 600px;
        font-size: 14px;
        font-weight: 600;
    }
    .meeting-jj {
        background: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        color: #fff;
        line-height: 35px;
        width: 700px;
        padding: 20px 30px;
        letter-spacing: 1px;
        margin-top: 60px;
    }
    .meeting-jj-title {
        font-size: 20px;
        margin-bottom: 10px;
    }
    .meeting-yt {
        margin-top: 60px;
    }
    
    .meeting-yt-title {
        background: url('../../assets/images/2022nianhui/会议赞助标签.png') no-repeat;
        background-size: calc(519px * 1) calc(163px * 0.7);
        height: calc(163px * 0.7);
		background-position: 50% 50%;
    }
	
	.meeting-yt-title.t1 {
	    background: url('../../assets/images/2022nianhui/会议地点.png') no-repeat;
		background-size: calc(519px * 0.7) calc(163px * 0.7);
		height: calc(163px * 0.7);
		background-position: 50% 50%;
	}
	
	.meeting-yt-title.t2 {
	    background: url('../../assets/images/2022nianhui/会务联系.png') no-repeat;
		background-size: calc(519px * 0.7) calc(163px * 0.7);
		height: calc(163px * 0.7);
		background-position: 50% 50%;
	}
	
    .meeting-yt-title1 {
        background: url('../../assets/images/ej/activeTitlebg2.png') no-repeat;
        background-size: 100% 100%;
    }
    .meeting-yt-title span {
        background-image: -webkit-linear-gradient(bottom, #ffc67d, #f6c195, #fbdcbf); 
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
        line-height: 60px;
        font-size: 30px;
        font-weight: 600;
    }
    .meeting-yc-content {
        width: 1000px;
        box-sizing: border-box;
    }
    .meeting-yc-content > h2 {
        border-left: 10px solid #8e3837;
        padding-left: 20px;
        color: #8e3837;
    }
    .line { border-top: 1px solid #8e3837; margin-top: 10px; }
    .time-line-content { position: relative; margin-top: 40px; }
    .time-line-content span { display: inline-block; font-size: 16px; vertical-align: top; }
    .point {
        background: url('../../assets/images/ej/activeTimePoint.png') no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 15px;
        margin: 0 30px;
        vertical-align: bottom;
        margin-top: 4px;
    }
    .right-text {
        color: #282828;
        margin-left: 30px;
        font-weight: 600;
        line-height: 30px;
        margin-top: -5px;
    }
    .time-line-content .right-intro {
        color: #282828;
        font-size: 14px;
        line-height: 40px;
    }
    .shuline {
        position: absolute;
        height: 80px;
        border-left: 1px solid #ccc;
        top: 20px;
        left: 136px;
    }
    .meeting-jbjs {
        border: 8px solid #ffc67d;
        box-sizing: border-box;
        width: 1000px;
        padding: 20px;
        color: #8e3837;
    }
    .detail-user-img { width: 100%; height: 200px;  }
    .index-quote-list-box { width: 1000px; height: 360px; overflow: hidden; box-sizing: border-box; border: 8px solid #ffc67d; margin: 30px auto; }
    .index-quote-list-box .img-box { padding: 30px 10px 10px 10px;  }
    .index-quote-list-box p { line-height: 40px; font-size: 16px; color: #8e3837; }
    .meeting-zanzhu { width: 1000px; }
    .zanzhu-title,
    .zanzhu-subtitle { color: #fd7744; font-size: 18px; }
    .zanzhu-subtitle { color: #fd7744; }
    .zanzhu-left,
    .zanzhu-center,
    .zanzhu-right { line-height: 35px; width: 100%; background: url('../../assets/images/ej/one1.png') no-repeat; background-size: 100% 100%; margin: 10px 0; font-size: 14px; color: #fff;}
    .zanzhu-center { background: url('../../assets/images/ej/two1.png') no-repeat; background-size: 100% 100%; }
    .zanzhu-right { background: url('../../assets/images/ej/three1.png') no-repeat; background-size: 100% 100%; }
    .meeting-address { padding-bottom: 30px; }
    .address-bg {
        /* background: url('../../assets/images/ej/addressbg.png') no-repeat;
        background-size: 100% 100%; */
        /* padding-top: 50px; */
        /* padding: 20px; */
        border: 8px solid #ffc67d;
        width: 1000px;
        margin: auto;
    }
    .address-bg img { width: 100%; }
    .meeting-concat { width: 1000px; }

    .tab-box {
        width: calc(100vw - 17px);
		height: 200px;
		margin: 0px auto 0 auto;
		background: url('../../assets/images/2022nianhui/点击跳转.jpg') no-repeat;
		background-size: 100% 100%;
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding-left: 19vw;
		padding-right: 19vw;
    }
	.fixed {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 999;
	}
    .tab-i {
        display: inline-block;
        width: 180px;
        height: 60px;
        margin: 10px;
		margin-top: 58px;
        text-align: center;
        line-height: 38px;
        font-size: 24px;
        color: #FFFFFF;
        cursor: pointer;
        letter-spacing: 2px;
		font-weight: bold;
    }
	
	.tab-i.t1 {
		margin-right: 3.5vw;
	}
	
	.tab-i.t2 {
		margin-right: 5vw;
	}
	
	.tab-i.t3 {
		margin-left: 5vw;
	}
	
	.tab-i.t4 {
		margin-left: 3.5vw;
	}
	
	.tab-i span {
		font-size: 18px;
		font-weight: normal;
	}
	
    .tab-i:hover, .tab-i.active {
        font-weight: bold;
    }
</style> 